import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL, apiUrl } from '../config/api';

export default function Mecanici({ currentUser, currentUserRole }) {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ nume: '' });
  const [editing, setEditing] = useState(null); // obiectul selectat
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const isOperator = (currentUserRole === 'Operatori' || currentUserRole === 'Operator');

  async function load() { try { const r = await axios.get(`${API_BASE_URL}/mecanici`); setRows(r.data); } catch (e) { setError('Eroare la încărcare'); } }
  useEffect(() => { load(); }, []);

  function reset() { setEditing(null); setForm({ nume: '' }); setShowModal(false); }

  async function save() {
    if (isOperator) { setError('Nu aveți permisiunea'); return; }
    if (!form.nume.trim()) { setError('Nume obligatoriu'); return; }
    try {
      if (editing) {
        await axios.put(`${API_BASE_URL}/mecanici/${editing.id}`, { nume: form.nume, currentUser: currentUser?.username });
      } else {
        await axios.post(`${API_BASE_URL}/mecanici`, { nume: form.nume, createdBy: currentUser?.username });
      }
      reset(); load();
    } catch (e) { setError(e.response?.data?.error || 'Eroare la salvare'); }
  }

  async function remove(r) {
    if (isOperator) { setError('Nu aveți permisiunea'); return; }
    if (!window.confirm(`Șterge ${r.nume}?`)) return;
    try { await axios.delete(`${API_BASE_URL}/mecanici/${r.id}`, { data: { currentUser: currentUser?.username } }); load(); } catch (e) { setError(e.response?.data?.error || 'Eroare la ștergere'); }
  }

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
  <h2 style={{ margin: 0 }}>Mecanici</h2>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button
            className="btn btn-primary"
            onClick={() => { setEditing(null); setForm({ nume: '' }); setShowModal(true); setError(''); }}
            disabled={isOperator}
          >
            Adaugă Mecanic
          </button>
        </div>
      </div>
      {error && (
        <div style={{
          background: error.includes('succes') ? '#d1e7dd' : '#f8d7da',
          color: error.includes('succes') ? '#0f5132' : '#721c24',
          padding: '0.6rem', borderRadius: '4px', marginBottom: '1rem',
          border: error.includes('succes') ? '1px solid #badbcc' : '1px solid #f5c6cb'
        }}>{error}</div>
      )}

      <div style={{ overflowX: 'auto' }}>
  <table className="data-table compact mecanici-table" style={{ fontSize: '1rem' }}>
          <thead><tr><th>Nume</th><th>Creat de</th><th style={{ textAlign: 'center' }}>Acțiuni</th></tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td>{r.nume}</td>
                <td>{r.createdBy || ''}</td>
                <td style={{ textAlign: 'center' }}>
                  <button className="btn action-btn" onClick={() => { setEditing(r); setForm({ nume: r.nume }); setShowModal(true); }}>Editează</button>
                  <button className="btn danger action-btn" onClick={() => remove(r)}>Șterge</button>
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={3}>Nu există înregistrări.</td></tr>}
          </tbody>
        </table>
      </div>
      {showModal && (
        <div className="modal-overlay modal-center">
          <div className="modal-content" style={{ maxWidth: '420px', padding: '1.5rem' }}>
            <h3 style={{ marginTop: 0, marginBottom: '1rem' }}>{editing ? 'Editează Mecanic' : 'Adaugă Mecanic'}</h3>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.4rem' }}>Nume *</label>
              <input
                autoFocus
                value={form.nume}
                onChange={e => setForm({ ...form, nume: e.target.value })}
                className="form-input"
                placeholder="Introduceți numele"
              />
            </div>
            {error && (
              <div style={{ background: '#f8d7da', color: '#721c24', padding: '0.5rem', borderRadius: 4, marginBottom: '0.75rem' }}>{error}</div>
            )}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '.5rem' }}>
              <button className="btn btn-secondary" onClick={reset}>Anulează</button>
              <button className="btn btn-success" onClick={save} disabled={isOperator || !form.nume.trim()}>Salvează</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
